module.exports = __webpack_public_path__ + "img/icon-light-text-blue.30d455e2.svg";